export default __webpack_public_path__ + "static/media/Address.e9a71466.png";